<script>
import Title from '@components/section-title'
import rules from '@constants/Rules'
import Vue from 'vue'
import AtivoShort from '@modal/pesquisa-ativo-short'
import AtivoLong from '@modal/pesquisa-ativo-long'
import EditarAtivo from '@modal/simulador-editar-ativo'
import store from '@state/store'
import { getNumber } from '@utils/Format'
import { MODAL } from '@constants/Text'

export default {
  components: {
    Title,
    AtivoShort,
    AtivoLong,
    EditarAtivo,
  },
  props: {
    bus: {
      type: Object,
      default: null,
      required: true,
    },
    plTotal: {
      type: Number,
      default: 0.0,
    },
    fixados: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      rules: rules,
      busModal: new Vue(),
      loading: false,
      ativoOld: {
        nome_ativo: '',
        pl: '',
        classe: '',
        tipo: '',
      },
      ativoNew: {
        nome_ativo: '',
        pl: '',
        classe: '',
        tipo: '',
      },
    }
  },
  computed: {
    usuarioAtual() {
      return store.getters['user/currentUser'] || {}
    },
  },
  created() {
    this.bus.$on(MODAL.CHANGE_ASSET, this.open)
    this.busModal.$on('select-assets', this.receiveAsset)
  },
  beforeDestroy() {
    this.busModal.$off('select-assets', this.receiveAsset)
  },
  methods: {
    getNumber(d) {
      return getNumber(d)
    },
    open(asset) {
      if (asset) {
        this.ativoOld = { ...asset }
        // this.ativoOld.pl = 'R$ 0,00' // asset.aplicacao
        this.ativoNew.pl = getNumber(asset['Aplicação'])
        // this.updateValueField(getNumber(asset['Aplicação']) * 100)
      }

      this.ativoNew.nome_ativo = ''
      this.ativoNew.classe = ''
      this.ativoNew.tipo = ''

      if (this.$refs.form) {
        this.$refs.form.resetValidation()
      }

      this.busModal.$emit('dialog', true)
    },
    // Caso seja necessario forcar a atualizacao do valor.
    // updateValueField(val) {
    //   if (
    //     this.$refs['edit-valor'] &&
    //     this.$refs['edit-valor'].$el.getElementsByTagName('input').length
    //   ) {
    //     Array.from(
    //       this.$refs['edit-valor'].$el.getElementsByTagName('input')
    //     ).forEach((i) => {
    //       i.value = val
    //       i.dispatchEvent(new Event('input'))
    //     })
    //   }
    // },
    openSearchShort() {
      this.busModal.$emit(MODAL.SEARCH_ASSET_SHORT, true)
    },
    receiveAsset(assets) {
      this.ativoNew.nome_ativo = assets[0].nome_ativo
      this.ativoNew.classe = assets[0].classe
      this.ativoNew.pl = Math.round10(getNumber(assets[0].pl), -2)
      this.ativoNew.tipo = assets[0].tipo || assets[0].Tipo
    },
    async enviar() {
      if (this.loading) {
        return
      }
      if (!this.$refs.form.validate()) {
        return
      }
      this.loading = true

      const existente = this.fixados.find((a) => {
        return a.nome_ativo === this.ativoNew.nome_ativo
      })

      if (existente) {
        this.$showSnack({
          text: 'Este ativo já está fixado',
          button: true,
        })
      } else {
        setTimeout(() => {
          this.busModal.$emit('dialog', false)
          this.bus.$emit('changed_asset', {
            novo: this.ativoNew,
            antigo: this.ativoOld,
          })
        }, 500)
      }
      this.loading = false
    },
  },
}
</script>

<template>
  <BaseModal :bus="busModal" max-width="700px">
    <Title
      title="Faça a troca do ativo"
      subtitle="Preencha abaixo para concluir"
    />

    <v-form ref="form" class="row" @submit.prevent>
      <div class="col-12">
        <h2 class="subhead">Ativo atual</h2>
        <div class="row">
          <v-text-field
            v-model="ativoOld.nome_ativo"
            label="Nome do ativo"
            readonly
            class="col-8"
          />
          <v-text-field
            label="P/L sugerido"
            value="R$ 0,00"
            readonly
            class="col-4"
          />
        </div>
      </div>
      <div class="col-12">
        <h2 class="subhead">Novo ativo</h2>
        <div class="row">
          <v-text-field
            v-model="ativoNew.nome_ativo"
            label="Nome do ativo*"
            class="col-8"
            required
            :rules="[rules.required]"
          />
          <v-currency-field
            ref="edit-valor"
            v-model="ativoNew.pl"
            prefix="R$ "
            label="P/L sugerido*"
            class="col-4"
            required
            :rules="[rules.required, rules.positive]"
          />
        </div>
      </div>
    </v-form>

    <template v-slot:actions="{ close }">
      <v-spacer />
      <BaseButton underlined @click="close"> Cancelar </BaseButton>
      <BaseButton dark @click="openSearchShort"> Procurar ativo </BaseButton>
      <BaseButton primary :loading="loading" @click="enviar">
        Trocar ativo
      </BaseButton>
      <v-spacer />
    </template>

    <AtivoShort
      :bus="busModal"
      only-one
      :pl-total="plTotal"
      :pl-sugerido="getNumber(ativoNew.pl)"
      :fixados="fixados"
    />
    <AtivoLong
      :bus="busModal"
      only-one
      :pl-total="plTotal"
      :pl-sugerido="getNumber(ativoNew.pl)"
      :fixados="fixados"
    />
    <EditarAtivo :bus="busModal" only-one :pl-total="plTotal" />
  </BaseModal>
</template>


